angular.module('businessThread')
    .component('businessThreadTaskTable', {
        bindings: {
            ids: '<',
            query: '<',
            onDataLoaded: '&'
        },
        templateUrl: 'app/business-thread/task-table.html',
        controller: function ($scope, Task, TaskService) {
            this.TaskService = TaskService
            this.filters = {}

            this.$onChanges = () => this.load()

            this.load = () => {
                if (angular.isArray(this.ids) && !this.ids.length) {
                    this.page = emptyPage()
                    this.notifyLoaded()
                    return
                }

                let params = angular.extend({}, this.filters, {
                    ids: this.ids,
                    search: this.query
                })
                return Task.table(params).$promise.then(data => {
                    this.page = data
                    this.notifyLoaded()
                })
            }

            this.notifyLoaded = () => {
                if (angular.isFunction(this.onDataLoaded)) {
                    this.onDataLoaded({$page: this.page})
                }
            }
            this.getDuration = (start, end) => start && end ? moment.preciseDiff(moment(start), moment(end)) : null

            $scope.$on('task.updated', () => this.load())
            $scope.$on('task.deleted', () => this.load())

            const emptyPage = () => ({list: [], fullListSize: 0, objectsPerPage: 50, pageNumber: 1})
        }
    })
